/**
 * jQuery plugin to lazy load iframes
 * depends on jquery.animateOnScroll.js
 * created by bogdan.b@codingheads.com
 * requires IntersectionObserver and jquery.animateOnScroll.js
 */

jQuery(function($) {
  // the animateOnScroll options
  const options = {
    animatedClass: 'iframe-loaded',
    callback: iframeContainer => {
      // remove all other content - that is, the placeholder image
      $(iframeContainer)
        .find(
          '> *:not(iframe[data-lazysrc]):not(.iframe-content):not(.controls)'
        )
        .remove();
      iframeContainer.removeAttribute('data-lazy-iframe');
      const iframe = iframeContainer.querySelector('iframe[data-lazysrc]'),
        iframeBg = iframe.closest('.bg-video-container');
      iframeContainer.classList.add('playback-waiting');
      iframe.src = iframe.dataset.lazysrc;
      if (iframeBg) {
        if (iframeBg.classList.contains('vimeo')) {
          const player = new Vimeo.Player(iframe); // using the latest Vimeo API
          // show the player when it's actually started playing
          window.player = player;
          player.on('loaded', (data) => {
            console.log('loaded', data);
            player.setMuted( true ).then(() => {
              player.play();
            });
            setTimeout(() => {
              iframeBg.style.background = 'none';
              iframeContainer.classList.remove('playback-waiting');
              iframeContainer.classList.add('playback-started');
            }, 50);
          });
          // also have a fallback
          iframe.addEventListener('load', () =>
            setTimeout(() => {
              iframeBg.style.background = 'none';
              iframeContainer.classList.remove('playback-waiting');
              iframeContainer.classList.add('playback-started');
            }, 1500)
          );

          // sound controls
          const mute = iframeContainer.querySelector('.controls .sound-mute'),
            unmute = iframeContainer.querySelector('.controls .sound-unmute');
          console.log(mute, unmute);
          if (mute)
            mute.addEventListener('click', () => {
              player.setMuted(true).then(() => {
                iframeContainer.classList.remove('unmuted');
                iframeContainer.classList.add('muted');
              });
            });
          if (unmute)
            unmute.addEventListener('click', () => {
              player.setMuted(false).then(() => {
                iframeContainer.classList.add('unmuted');
                iframeContainer.classList.remove('muted');
              });
            });
        } else {
          iframe.addEventListener('load', () =>
            setTimeout(() => {
              iframeBg.style.background = 'none';
              iframeContainer.classList.remove('playback-waiting');
              iframeContainer.classList.add('playback-started');
            }, 500)
          );
        }
      }
      iframe.removeAttribute('data-lazysrc');
    },
  };

  // lazy-load iframes
  $.fn.lazyIframe = function() {
    if (this.length) {
      // load this iframe after a delay - to help with the speed score??
      const defaultDelay = 0;
      this.each(function() {
        const lazyIframe = this,
          iframe = lazyIframe.querySelector('iframe[data-lazysrc]');
        if (iframe) {
          lazyIframe.dataset.lazyiframeInit = true; // prevent duplicate activations
          const delay =
            'lazyIframeDelay' in lazyIframe.dataset
              ? parseInt(lazyIframe.dataset.lazyIframeDelay)
              : defaultDelay;
          setTimeout(() => {
            $(lazyIframe).animateOnScroll(options);
          }, delay);
        }
      });
    }
    return this;
  };
});
